import React from 'react';
import { Phone, AlertTriangle, Info } from 'lucide-react';
export function PowerStrokePage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-7421">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-7422">
        <div className="container mx-auto px-4" data-id="element-7423">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-7424">
            Ford Powerstroke Engine Repair
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-7425">
            Expert Service for All Powerstroke Models
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-7426">
        <div className="max-w-4xl mx-auto" data-id="element-7427">
          {/* Three Engine Models */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7428">
            <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-7429">
              <div className="text-center" data-id="element-7430">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/7.3.jpg?opt=w3" alt="7.3 Powerstroke" className="w-full h-auto rounded-lg mb-4" data-id="element-7431" />
                <a href="/services/powerstroke-7-3" className="text-lg font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7432">
                  7.3 Power Stroke
                </a>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7433">The "Good"</p>
              </div>

              <div className="text-center" data-id="element-7434">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/6.0l.jpg?opt=w3" alt="6.0 Powerstroke" className="w-full h-auto rounded-lg mb-4" data-id="element-7435" />
                <a href="/services/powerstroke-6-0" className="text-lg font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7436">
                  6.0 Power Stroke
                </a>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7437">The "Bad"</p>
              </div>

              <div className="text-center" data-id="element-7438">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/imagesCAB65B34.jpg?opt=w3" alt="6.4 Powerstroke" className="w-full h-auto rounded-lg mb-4" data-id="element-7439" />
                <a href="/services/powerstroke-6-4" className="text-lg font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7440">
                  6.4 Power Stroke
                </a>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7441">The "Ugly"</p>
              </div>
            </div>
          </div>

          {/* 7.3L Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7442">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-7443">
              7.3 liter Power Stroke Engine
            </h2>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-7444">
              7.3 Powerstroke
            </h3>

            <p className="text-gray-700 mb-4" data-id="element-7445">
              The first 7.3L was produced from 1988-1993. The original 7.3L
              diesel was a non-turbo charged indirect injection (IDI) engine,
              followed shortly after by a turbo charged version. It was very
              similar to the previous 6.9l IDI diesel engine, which was simply
              bored out for more torque. This engine is not considered in the
              powerstroke family. In 1994, the 7.3L underwent some changes. The
              7.3L was changed to a direct injection (DI) engine from the
              original IDI engine.
            </p>

            <p className="text-gray-700" data-id="element-7446">
              We{' '}
              <a href="/services/powerstroke-7-3" className="text-[#B1050B] hover:text-[#8A0408] font-semibold underline" data-id="element-7447">
                repair 7.3L PowerStroke
              </a>{' '}
              Diesel Engines.
            </p>
          </div>

          {/* 6.0L Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7448">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-7449">
              Common 6.0L Power Stroke Problems
            </h2>

            <div className="flex justify-center mb-6" data-id="element-7450">
              <img src="//drwzpk38qkpfb.cloudfront.net/core/getthumb?file=uploaded%2Fimages%2Ftruck%20pictures%2Fiphone%20import%20008.JPG400x400.jpg&site=1986&w=265&h=319&user=1617&opt=w3" alt="6.0L Powerstroke truck" className="max-w-[265px] h-auto rounded-lg shadow-md" data-id="element-7451" />
            </div>

            <p className="text-gray-700 mb-4" data-id="element-7452">
              The 6.0 liter Power Stroke is a great diesel, despite a bundle of
              issues that plagued many of the early engines. The 6.0 is
              powerful, durable, & reliable. There are more than enough
              satisfied 6.0L owners to back those statements up. However, some
              of the 6.0L components are prone to problems, especially when
              maintenance is neglected or the performance is increased by means
              of aftermarket components.
            </p>

            <div className="bg-yellow-50 border-l-4 border-yellow-400 p-6" data-id="element-7453">
              <p className="text-gray-800" data-id="element-7454">
                It's critical to maintain your powerstroke. Garrett Auto and
                Truck repair has expert certified{' '}
                <a href="/services/powerstroke-6-0" className="text-[#B1050B] hover:text-[#8A0408] font-semibold underline" data-id="element-7455">
                  6.0L Powerstroke Engine Repair
                </a>{' '}
                mechanics ready to inspect your powerstroke.
              </p>
            </div>
          </div>

          {/* 6.4L Section */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7456">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-7457">
              The 6.4 Power Stroke
            </h2>

            <p className="text-gray-700 mb-4" data-id="element-7458">
              We are expert diesel mechanics. We inspect, diagnose and repair (
              <a href="/services/powerstroke-6-4" className="text-[#B1050B] hover:text-[#8A0408] font-semibold underline" data-id="element-7459">
                6.4 PowerStroke Repair
              </a>
              ).
            </p>

            <p className="text-gray-700 mb-4" data-id="element-7460">
              The 6.4 L Power Stroke, used in 2008 model year Ford Super Duty
              trucks, is a V8 turbodiesel engine. The engine has a sequential
              twin-turbo intercooled forced induction system. The engine also
              uses a high pressure common rail fuel injection system. It
              produces 350 hp (260 kW) at 3000 rpm and 650 ft·lbf (880 N·m) of
              torque at 2000 rpm.
            </p>

            <p className="text-gray-700 mb-4" data-id="element-7461">
              This engine is also used in International trucks and buses under
              the name <strong data-id="element-7462">MaxxForce 7</strong>. However, the MaxxForce 7
              will not have the sequential turbocharger system; rather, it will
              use a single stage variable vane turbocharger. Displacement and
              injector systems are the same. In MaxxForce 7 guise, the engine
              will produce between 200-230 hp and 580–620 ft·lbf of torque.
            </p>

            <p className="text-gray-700 mb-6" data-id="element-7463">
              For the 2010 model year, Navistar has upgraded the MaxxForce 7
              with dual sequential turbochargers, giving it a new power range
              (220-300 hp @ 2600 rpm and 520–660 ft·lbf of torque @ 1600-2200
              rpm).
            </p>

            <div className="bg-red-50 border-l-4 border-red-500 p-6 mb-6" data-id="element-7464">
              <p className="text-gray-800 font-semibold mb-4" data-id="element-7465">
                The biggest complaint we hear about the 6.4 turbo diesel
                powerstroke from our customers is poor fuel economy. Read below,
                these posts are taken from internet blogs.
              </p>
            </div>

            {/* Customer Testimonials */}
            <div className="space-y-6" data-id="element-7466">
              <div className="bg-gray-50 border-l-4 border-gray-400 p-6 italic" data-id="element-7467">
                <p className="text-gray-700" data-id="element-7468">
                  I bought my 08 F350 Super Cab FX4 in Dec 07 for a couple of
                  reasons. I had on 04 F350 with the 6.0 it was fast, MPG was
                  about 13 but man you could hear me coming from a mile away.
                  The new 6.4 was quiet, dealer told me to expect 15 to 18 MPG
                  and it was faster than my 04, with still all of the towing
                  capacity. FAST FORWARD to the real world. I baby this truck, I
                  have 3700 miles on her and I am getting on average 9.5 MPG,
                  when I am hauling my trailer I am getting 7 MPG. And it isn't
                  faster than my 04 F350.
                </p>
              </div>

              <div className="bg-gray-50 border-l-4 border-gray-400 p-6 italic" data-id="element-7469">
                <p className="text-gray-700" data-id="element-7470">
                  I love the truck, it is tough looking, very quiet and it does
                  have good towing capacity, but the mileage is killing me. I am
                  even considering a different truck because the mileage is so
                  poor. For all of you out there who claim 15 MPG and more,
                  please tell me how you are getting it.
                </p>
              </div>

              <div className="bg-gray-50 border-l-4 border-gray-400 p-6 italic" data-id="element-7471">
                <p className="text-gray-700 mb-4" data-id="element-7472">
                  Love the 7.3 Gave my son my old 1997 F-250 2wd 5-speed 4.10
                  gears 7.3 (8,800 GVWR) back when it had 220,000 miles on it.
                  244,000 now. Gets 15 around town carrying 1,000 lbs of pool
                  chemicals. Gets 20 on the interstate @ about 75mph. I bought a
                  08 6.4 F-250 4 door 2wd automatic 3.73 gears (9,800 GVWR). I
                  initially got 9.5 to 11.5 mpg around town. At just over 6,000
                  miles it bumped up to 12.5 to 13.3 mpg around town. At that
                  time it got 16mpg @ 70mph on the interstate highway only. I
                  made one trip at 66 mph on cruise and the mileage kept
                  climbing until 21.2 mpg. If I pulled off the interstate
                  further than I could throw a rock the mileage drops like a
                  rock.
                </p>
                <p className="text-gray-700 mb-4" data-id="element-7473">
                  I love the truck. I buy one...pay for 5 years and drive it for
                  10. I average 22,000 miles per year. That should easily be
                  within the life of my truck. Do I wish the mileage was better?
                  You bet! Would I buy a Dodge or Chevy? Nope... Drove
                  both...not bad trucks ... just not what I liked. Dodge has a
                  great motor but the body feels, sounds, looks and is flimsy in
                  comparison. I still like the truck but didn't like the feel.
                  The Chevy just didn't have enough room. Stopped right there
                  with it. I even drove the Toyota gas motor full size. Tons of
                  power but had a cheap look on the inside of the truck. It was
                  a very nice truck but I wanted the longevity of a diesel.
                </p>
                <p className="text-gray-700" data-id="element-7474">
                  I have about 17,000 miles on my 6.4. At 36,000 it will
                  probably lose its dpf and get a 5" exhaust. Will check mileage
                  figures then. Had a 7.3 got a 6.4 wish I had a 7.3 again!
                </p>
              </div>

              <div className="text-sm text-gray-600 italic" data-id="element-7475">
                <p data-id="element-7476">
                  Read more:{' '}
                  <a href="http://forums.dieselpowermag.com/70/6651211/power-stroke/anyone-getting-decent-mileage-on-64-power-stroke/page2.html" target="_blank" rel="noopener noreferrer" className="text-[#B1050B] hover:text-[#8A0408] underline" data-id="element-7477">
                    http://forums.dieselpowermag.com
                  </a>
                </p>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7478">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-7479">
              Learn More About Each Engine
            </h2>
            <div className="grid md:grid-cols-3 gap-4" data-id="element-7480">
              <a href="/services/powerstroke-7-3" className="bg-green-50 hover:bg-green-100 border-2 border-green-500 rounded-lg p-6 text-center transition-colors" data-id="element-7481">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7482">
                  7.3L Powerstroke
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-7483">
                  The most reliable Powerstroke
                </p>
              </a>

              <a href="/services/powerstroke-6-0" className="bg-yellow-50 hover:bg-yellow-100 border-2 border-yellow-500 rounded-lg p-6 text-center transition-colors" data-id="element-7484">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7485">
                  6.0L Powerstroke
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-7486">
                  Common problems & solutions
                </p>
              </a>

              <a href="/services/powerstroke-6-4" className="bg-red-50 hover:bg-red-100 border-2 border-red-500 rounded-lg p-6 text-center transition-colors" data-id="element-7487">
                <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-7488">
                  6.4L Powerstroke
                </h3>
                <p className="text-gray-700 text-sm" data-id="element-7489">Fuel economy concerns</p>
              </a>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-7490">
            <h2 className="text-3xl font-bold mb-4" data-id="element-7491">
              Expert Powerstroke Service
            </h2>
            <p className="text-xl mb-6" data-id="element-7492">
              Get professional diagnostics and repair for all Powerstroke models
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-7493">
              <Phone className="mr-3" size={24} data-id="element-7494" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-7495">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}